import { request } from '@src/utils/request';
import type { MyCityMapItem, SystemGeoItem } from './types';

// GET /api/map/citymap/myCityMapList - 获取我的城市地图列表
export const getMapCitymapMyCityMapList = (params: { userId: string }) =>
    request<MyCityMapItem[]>({
        url: '/api/map/citymap/myCityMapList',
        method: 'get',
        params,
    });

// POST /api/system/geo/list - 获取城市列表
export const postSystemGeoList = () =>
    request<SystemGeoItem[]>({
        url: '/api/system/geo/list',
        method: 'post',
    });
